import mdgtPlayers from '../data/mdgt.js';
import MdgtLogo from '../assets/mdgt-64.png';
import RatingPage from './RatingPage';

const MdgtRatings = () => {
  return (
    <div>
      <RatingPage playerData={mdgtPlayers}>
        MDGT <img src={MdgtLogo} alt="" style={{backgroundColor: '#000', color: '#fff'}}/>
      </RatingPage>
    </div>
  );
};

export default MdgtRatings;
